import { useState, useEffect } from 'react'

export const useCurrentUrl = () => {
  const [url, setUrl] = useState(
    typeof window === 'undefined' ? '' : window.location.href,
  )

  useEffect(() => {
    const handleUrlChange = () => {
      setUrl(window.location.href)
    }

    window.addEventListener('popstate', handleUrlChange)

    const originalPushState = history.pushState
    const originalReplaceState = history.replaceState

    history.pushState = function (...args) {
      originalPushState.apply(this, args)
      handleUrlChange()
    }

    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args)
      handleUrlChange()
    }

    return () => {
      window.removeEventListener('popstate', handleUrlChange)
      history.pushState = originalPushState
      history.replaceState = originalReplaceState
    }
  }, [])

  return url
}
